import { Facebook, Discord } from 'react-bootstrap-icons';
import XtremeTop100 from '../images/xtremetop.png';

const SOCIAL_LINKS = [
  {
    href: 'https://discord.gg/F7tUnrBMDY',
    label: 'Discord',
    icon: <Discord />,
    ariaLabel: 'Paragon Conquer Discord Server',
  },
  {
    href: 'https://www.facebook.com/Paragon-Conquer-103703422181032',
    label: 'Facebook',
    icon: <Facebook />,
    ariaLabel: 'Paragon Conquer Facebook Page',
  },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="ft-footer">
      <div className="ft-inner">
        <div className="ft-brand">
          <span className="ft-name">Paragon Conquer</span>
          <span className="ft-copy">&copy; 2022{year > 2022 ? `\u2013${year}` : ''} &middot; All Rights Reserved</span>
        </div>

        <div className="ft-social">
          {SOCIAL_LINKS.map(({ href, label, icon, ariaLabel }) => (
            <a
              key={label}
              className="ft-social-link"
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={ariaLabel}
            >
              <span className="ft-social-icon">{icon}</span>
              <span className="ft-social-label">{label}</span>
            </a>
          ))}
        </div>

        <div className="ft-vote">
          <span className="ft-vote-label">Support us</span>
          <a
            href="https://www.xtremetop100.com/in.php?site=1132372689"
            target="_blank"
            rel="noreferrer"
            aria-label="Vote for Paragon Conquer on XtremeTop100"
          >
            <img className="ft-vote-img" src={XtremeTop100} alt="Vote on XtremeTop100" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
